import React from 'react'
import { Typography } from 'antd'

const { Title } = Typography

function Category() {
  return (
    <div className="page-container">
      <Title level={2}>分类页面</Title>
      <p>分类浏览功能开发中...</p>
    </div>
  )
}

export default Category